import React from 'react'
import styles from './footer.module.css'

export default () => (
  <footer className={styles.footer}>
    Copyright © 2026 by Liliana Folta, All Rights Reserved.
  </footer>
)
